var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"fp-icon-container"},_vm.$listeners),[_c('div',{staticClass:"fp-icon-svg",class:'icon-' + _vm.icon,style:((_vm.color ? 'background:' + _vm.color + ';' : '') +
      (_vm.size ? 'width:' + _vm.size + 'px;height:' + _vm.size + 'px;' : ''))})])}
var staticRenderFns = []

export { render, staticRenderFns }